<template lang="html">
  <div class="theme" :class="themeClasses">
    <div
      class="cover-image"
      @click="expand"
      :style="`background-image:url('${themeImage}')`"></div>

    <div class="theme-inner">
      <div
        class="theme-image"
        @click="expand"
        :style="`background-image:url('${themeImage}')`">
      </div>

      <div class="theme-info">
        <h2 class="theme-name">{{theme.name}}</h2>

        <div class="theme-actions">
          <btn @click="expand" primary class="btn-preview">
            <Sprite v-if="expanded" name="zoom-out"/>
            <Sprite v-else name="zoom-in"/>
          </btn>

          <div>
            <transition name="fade" mode="out-in">
              <div key="is-current" v-if="themeActive" class="is-current">Current</div>
              <btn key="set-current" v-else tertiary @click="setTheme(theme)">Set theme</btn>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'
import Btn from '@/components/Btn'

export default {
  name: 'Theme',

  data() {
    return {
      expanded: false
    }
  },

  props: ['theme', 'activeTheme', 'themeImage'],

  components: {
    Sprite,
    Btn
  },

  computed: {
    themeClasses() {
      return [
        {'is-active': this.themeActive},
        {'has-expanded': this.expanded}
      ]
    },

    themeActive() {
      return this.theme === this.activeTheme
    }
  },

  methods: {
    setTheme(theme) {
      this.$emit('setTheme', theme)
    },

    expand() {
      this.expanded = !this.expanded

      window.setTimeout(() => {
        this.$emit('expanded')
      }, 500)
    }
  }
}
</script>

<style lang="sass">
  @import '../stylesheets/base/variables'
  @import '../stylesheets/base/theme'
  @import '../stylesheets/helpers/mixins'
  @import '../stylesheets/helpers/extends'

  $row-height: 200px
  $controls: 3

  .theme
    height: $row-height
    border-radius: 5px
    background: $color-column
    margin-bottom: $gap-medium
    position: relative
    border: 2px solid rgba(0, 0, 0, 0.025)
    transition: height .3s ease-in-out, padding-bottom .3s .1s ease-in-out
    overflow: hidden

    &.has-expanded
      height: 0
      padding-bottom: 100%
      transition: height .3s .3s ease-in-out, padding-bottom .3s ease-in-out

      .cover-image
        pointer-events: all
        width: 100%
        height: 100%

      .theme-controls
        left: 100%
        transition-delay: .075s
        transform: translateX(-100%)

      .theme-info
        .btn
          background: rgba(0, 0, 0, 0.25)

        .is-current
          background: #fff

    .theme-inner
      display: flex
      align-items: center

    .theme-image
      height: $row-height
      background-size: cover
      background-position: 50% 50%
      flex-basis: $row-height
      cursor: zoom-in

    .cover-image
      pointer-events: none
      width: $row-height
      height: $row-height
      position: absolute
      top: 0
      left: 0
      background-position: 50% 50%
      background-size: cover
      transition: all .5s ease-in-out
      cursor: zoom-out

    .theme-actions
      display: flex
      align-items: center

    .theme-controls
      position: absolute
      left: $row-height
      transition: all .4s ease-in-out

      .control
        background: rgba(0, 0, 0, 0.25)
        height: $row-height/$controls
        text-align: center
        padding: 0 10px

        .sprite
          position: relative
          top: 25px

    .theme-info
      padding: $gap-small $gap-medium
      display: flex
      flex-direction: column

      .theme-name
        font-size: 18px

        @include themify($themes)
          color: themed('color-body')

      .theme-actions
        position: absolute
        bottom: 5px
        right: 5px

      .btn-wrapper, .is-current
        padding: 6px
        transition: all .3s .2s ease-in-out

      .btn-preview
        margin-right: 5px
        padding: 0 5px
        min-width: 0

        .btn
          padding: 5px

        .sprite
          padding: 2px

      .is-current
        text-align: center
        text-transform: uppercase
        font-weight: bold
        letter-spacing: 1px
        border-radius: 3px
        min-width: 128px

        @include themify($themes)
          color: themed('color-secondary')

    &.is-active
      border-color: rgba(0, 0, 0, 0.25)
</style>
